import { createContext, Dispatch, FC, SetStateAction, useState } from "react"

export type GlobalContextType = {
  setOpenPopUp: Dispatch<SetStateAction<boolean>>
  openPopUp: boolean
  settings: {}
}

export const GlobalContext = createContext<GlobalContextType>(null)

const GlobalContextProvider: FC = ({ children }) => {
  const [openPopUp, setOpenPopUp] = useState<boolean>(false)

  const [settings, setSettings] = useState<{}>({})

  // useEffect(() => {
  //   getSettings()
  // }, [])

  // const getSettings = async () => {
  //   const settings = await api.getGeneralSettings().then(api.extractData)
  //   if (!settings) return
  //   const settingObj = {}
  //   settings.forEach(function (data) {
  //     settingObj[data.key] = data.value
  //   })
  //   setSettings(settingObj)
  // }

  return (
    <GlobalContext.Provider
      value={{
        setOpenPopUp,
        openPopUp,
        settings,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export default GlobalContextProvider
